import { Button, ModalFooter } from '@modusign/design-system';

interface InvitationFooterProps {
  closeButtonLabel: string;
  confirmButtonLabel: string;
  closeButtonDisabled?: boolean;
  confirmButtonDisabled?: boolean;
  isConfirmButtonLoading?: boolean;
  onConfirm: () => void;
  onClose: () => void;
}

export default function InvitationFooter({
  closeButtonLabel,
  confirmButtonLabel,
  isConfirmButtonLoading = false,
  closeButtonDisabled = false,
  confirmButtonDisabled = false,
  onClose,
  onConfirm,
}: InvitationFooterProps) {
  return (
    <ModalFooter alignSelf="center" mt={3}>
      <Button disabled={closeButtonDisabled} onClick={onClose}>
        {closeButtonLabel}
      </Button>
      <Button
        disabled={confirmButtonDisabled}
        isLoading={isConfirmButtonLoading}
        ml={3}
        variant="primary"
        onClick={onConfirm}
      >
        {confirmButtonLabel}
      </Button>
    </ModalFooter>
  );
}
